import React from "react";

/**
 * Crystalline wireframe-polygon framed icon — matches the Landing feature cards.
 * Used across the app for consistent visual language.
 */
const CrystalIcon = ({ icon: Icon, accent = "v0", size = 64 }) => (
  <div
    className="relative mx-auto mb-4"
    style={{ width: size, height: size }}
  >
    <svg viewBox="0 0 64 64" className="absolute inset-0 w-full h-full">
      <defs>
        <linearGradient id={`crystGrad-${accent}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="50%" stopColor="#a78bfa" />
          <stop offset="100%" stopColor="#e879f9" />
        </linearGradient>
      </defs>
      <polygon
        points="32,4 56,18 56,46 32,60 8,46 8,18"
        fill="none"
        stroke={`url(#crystGrad-${accent})`}
        strokeWidth="0.8"
        opacity="0.9"
      />
      <polygon
        points="32,4 56,18 56,46 32,60 8,46 8,18"
        fill={`url(#crystGrad-${accent})`}
        opacity="0.12"
      />
      <line x1="32" y1="4" x2="32" y2="60" stroke={`url(#crystGrad-${accent})`} strokeWidth="0.3" opacity="0.5" />
      <line x1="8" y1="18" x2="56" y2="46" stroke={`url(#crystGrad-${accent})`} strokeWidth="0.3" opacity="0.5" />
      <line x1="56" y1="18" x2="8" y2="46" stroke={`url(#crystGrad-${accent})`} strokeWidth="0.3" opacity="0.5" />
      {[[32, 4], [56, 18], [56, 46], [32, 60], [8, 46], [8, 18]].map(([cx, cy], i) => (
        <circle key={i} cx={cx} cy={cy} r="1.2" fill="#fff" opacity="0.9" />
      ))}
    </svg>
    <div className="absolute inset-0 flex items-center justify-center">
      <Icon
        className="text-white relative z-10 drop-shadow-[0_0_8px_rgba(217,70,239,0.7)]"
        size={Math.round(size * 0.375)}
      />
    </div>
  </div>
);

export default CrystalIcon;
